export default class PoliticaContratual {
    constructor() {
        this.id = null;
        this.descricao = null;
        // 1 marcação obrigatória
        // 2 marcação inexitente
        // 3 marcação automática
        // 4 marcação flexível
        this.parametroRefeicao = null;
        this.horasDSR = null;
        this.horaAdicionalNoturnoDe = null;
        this.horaAdicionalNoturnaAte = null;
        this.duracaoHoraNoturna = null;
        this.tempoInterjornada = null;
        this.horasMensaisalistas = null;
        this.descontarIntervalosNoturno = false;
        this.descontarSegundoIntervalo = false;
        // 1 horas legais
	    // 2 horas trabalhadas
        this.controleFalta = null;
    }    
}